import React from 'react';

/**
 * Adaptador local con la firma de `Avatar` (@ole/react-library-agents).
 * Hoy renderiza `div.avatar` (Aura, 38px, gradiente de marca). Migración (OUW-72): `<Avatar … />`.
 * `size` se acepta por firma; el tamaño Aura lo fija el CSS (38px) y solo se sobreescribe si se pasa.
 */
export type PortalAvatarProps = {
  name?: string;
  initials?: string;
  size?: number;
  testId?: string;
};

/** Misma regla que `getInitials` de la lib: primera letra de las dos primeras palabras. */
export function portalInitials(name?: string): string {
  if (!name) return '';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

export function PortalAvatar({ name, initials, size, testId }: PortalAvatarProps) {
  const text = initials ?? portalInitials(name);
  const style = size ? { width: size, height: size, flexBasis: size } : undefined;
  return (
    <div className="avatar" style={style} data-testid={testId} aria-label={name}>
      {text}
    </div>
  );
}
